// extracted by mini-css-extract-plugin
module.exports = {"logo":"AppLogo_logo__1viwO"};